/* eslint-disable complexity */
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
} from '@angular/core';
import { fadeIn } from '@animations/fade-in';
import { ThemeService } from '@shared/services/theme.service';
import { HotelStore } from '../hotel.store';
import { HotelDetailsResponse } from '../models/response/hotel-details.response';
import { ReservationResponse } from '../models/response/reservation.response';
import { Observable, tap } from 'rxjs';
import { RequestState } from '@shared/models/request-state';
import { SequenceView } from '@sequence/models/view/sequence.view';
import { environment } from '@environments/environment';

interface CustomWindow extends Window {
  isOpenedInWebView?: boolean;
  openedFromApaPilot?: boolean;
  apaPilotVersion?: string;
  userTheme?: 'light' | 'dark';
  userFontSize?: 'small' | 'medium' | 'large';
}

// Make custom window properties accessible.
declare let window: CustomWindow;

@Component({
  selector: 'app-hotel-info',
  templateUrl: './hotel-info.component.html',
  styleUrls: ['./hotel-info.component.scss'],
  animations: [fadeIn],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotelInfoComponent implements OnChanges {
  @Input() dutyPeriodIndex?: number;
  @Input() sequence?: SequenceView;
  reservation$?: Observable<RequestState<ReservationResponse>>;
  theme$ = this.themeService.theme$;

  constructor(
    private hotelStore: HotelStore,
    private themeService: ThemeService,
  ) {}

  ngOnChanges(): void {
    this.setObservable();
    console.log(this.dutyPeriodIndex);
  }

  getGoogleMapsLink(hotel: HotelDetailsResponse | undefined): string {
    if (hotel) {
      if (hotel?.googleMapLink) {
        return hotel.googleMapLink;
      }

      const urlEncodedAddress = hotel.address1.replace(' ', '+');
      const urlEncodedCity = hotel.city.replace(' ', '+');
      return `https://www.google.com/maps/search/?api=1&query=${urlEncodedAddress}+${urlEncodedCity}+${hotel.state}`;
    }
    return '';
  }

  getAPAHotelWebpageUrl(hotel: HotelDetailsResponse | undefined): string {
    // For APA Pilot 3
    if (window.apaPilotVersion) {
      const versionParts = window.apaPilotVersion.split('.');
      let useNewHotelLink = false;

      // Check for 3.0.25 or greater
      try {
        if (
          versionParts.length === 3 &&
          parseInt(versionParts[0]) >= 3 &&
          parseInt(versionParts[1]) >= 0 &&
          parseInt(versionParts[2]) >= 25
        ) {
          useNewHotelLink = true;
        }
      } catch (_) {
        // Pass
      }

      if (useNewHotelLink) {
        if (hotel?.apaHotelId) {
          return `appcode:HOT-https://hotel${environment.prefix}alliedpilots.org/Hotel/MobileView/?Id=${hotel.apaHotelId}`;
        }

        return `appcode:HOT-https://hotel${environment.prefix}alliedpilots.org/Hotel/MobileView/`;
      }
    }

    // Old style
    if (hotel?.apaHotelId) {
      return `https://www.alliedpilots.org/Tools/Hotels?Id=${hotel.apaHotelId}`;
    }

    return 'https://www.alliedpilots.org/Tools/Hotels';
  }

  private setObservable(isRefresh = false): void {
    if (this.dutyPeriodIndex !== undefined) {
      this.reservation$ = this.hotelStore
        .getHotel(this.dutyPeriodIndex, isRefresh)
        .pipe(tap((response) => console.log(response)));
    }
  }

  onRefreshClick(): void {
    this.setObservable(true);
  }
}
